

















import { Component, Mixins, Prop } from "vue-property-decorator";
import mixins from "../mixins";
@Component
export default class FitIconWechatPay extends Mixins(mixins) {
@Prop({ default: "#07C160" }) public fill;
@Prop({ default: 34 }) public size;
}
